<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_product" src="@/assets/images/icon_product.png" alt=""/>查询/修改订单</span>
      <el-main class="con">
        <el-form style="margin-left: 10px;margin-top: 10px" :disabled="loading">
          <el-form-item v-if="currentUser.userType === 1">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">客户姓名：</span>
            <el-select size="small"
                       v-model="selectedCustomer"
                       placeholder="请选择"
                       filterable
                       :filter-method="dataFilter"
                       ref="select"
                       :clearable="showClose"
                       @change="queryCenterSettle"
                       @blur.native.capture="onblur"
                       @hook:mounted="cancelReadOnly"
                       @visible-change="cancelReadOnly">
              <el-option
                v-for="item in customerOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="currentUser.userType === 2">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">客户姓名：{{customerInfo.name}}</span>
          </el-form-item>
          <el-form-item>
            <span style="color: red">*</span>
            <span style="margin-left: 5px">开始日期：</span>
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="beginDate"></el-date-picker>
            <span style="color: red;margin-left: 20px">*</span>
            <span style="margin-left: 5px">结束日期：</span>
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="endDate"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-radio-group v-model="billType">
              <el-radio label="0">
                <span style="color: black">查询订单</span>
              </el-radio>
              <el-radio label="1">
                <span style="color: black">查询已开票据</span>
              </el-radio>
              <el-radio label="2" v-if="currentUser.userType === 1">
                <span style="color: black">查询销售计划</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-radio-group v-model="billStatus">
              <el-radio label="0">
                <span style="color: black">全部</span>
              </el-radio>
              <el-radio label="1">
                <span style="color: black">保存</span>
              </el-radio>
              <el-radio label="2">
                <span style="color: black">提交</span>
              </el-radio>
              <el-radio label="4">
                <span style="color: black">审核</span>
              </el-radio>
              <el-radio label="7">
                <span style="color: black">关闭</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="currentUser.userType === 1 && selectedCustomer === ''">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">选择提货人后展示发货详情</span>
          </el-form-item>
          <el-form-item v-if="currentUser.userType === 1 && selectedCustomer !== ''">
            <el-radio v-model="stoDef" :key="index" :label="index" v-for="(storage,index) in storageOrgInfo" style="margin-top: 10px;margin-bottom: 10px;min-width: 20vw">
<!--            <el-radio v-model="selectedStorage" :key="sto.id" :label="sto.id" v-for="sto in storageOrgInfo" style="margin-top: 10px;margin-bottom: 10px;min-width: 20vw">-->
              <span style="color: black">
<!--                <span style="font-weight: bold">发货公司：</span>{{sto.name}}-->
<!--                <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ sto.orgCompany.name }}-->
                <span style="font-weight: bold">发货公司：</span>{{storage.name}}
              </span>
            </el-radio>
          </el-form-item>
          <el-form-item v-if="currentUser.userType === 2">
<!--            <el-radio>-->
<!--              <span style="color: black">-->
<!--                <span style="font-weight: bold">发货公司：</span>{{this.storageOrgDef.name}}-->
<!--                <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ this.storageOrgDef.orgCompany.name }}-->
<!--              </span>-->
<!--            </el-radio>-->
            <el-radio v-model="stoDef" :key="index" :label="index" v-for="(storage,index) in storageOrgInfo" style="margin-top: 10px;margin-bottom: 10px;min-width: 20vw">
<!--            <el-radio v-model="selectedStorage" :key="sto.id" :label="sto.id" v-for="sto in storageOrgInfo" style="margin-top: 10px;margin-bottom: 10px;min-width: 20vw">-->
              <span style="color: black">
<!--                <span style="font-weight: bold">发货公司：</span>{{sto.name}}-->
<!--                <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ sto.orgCompany.name }}-->
                <span style="font-weight: bold">发货公司：</span>{{storage.name}}
              </span>
            </el-radio>
          </el-form-item>
          <el-form-item class="submit">
            <el-button class="but" @click="queryBill" :loading="loading">提交查询信息</el-button>
          </el-form-item>
        </el-form>
      </el-main>
      <el-main class="list">
        <el-table :data="saleOrderList" show-summary border :summary-method="getSaleOrderSummaries" size="mini" v-if="this.billType==='0'">
          <el-table-column label="付款" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="info" :disabled="loading" @click="toPay(scope.row.amount)">直接付款</el-button>
            </template>
          </el-table-column>
          <el-table-column label="单据编号" prop="billNumber" min-width="150px" align="center"></el-table-column>
          <el-table-column label="单据状态" prop="status" align="center"></el-table-column>
          <el-table-column label="商品名称" align="center">
            <template slot-scope="scope">
              <span class="spa" v-for="(info,index) in scope.row.info">
                {{info.materialName}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="规格" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.packSpec}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.qty + info.saleUnitName}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="未提数量" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.associateQty + info.saleUnitName}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="金额（元）" prop="amount" align="center"></el-table-column>
          <el-table-column label="订货日期" prop="billDate" align="center"></el-table-column>
          <el-table-column label="备注" align="center" width="200px">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.description}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info" v-if="scope.row.status === '保存'">
                <el-button :disabled="loading" size="mini" type="primary" @click="editSaleOrder(info.entryid,info.materialID,scope.row.billID)">修改数量</el-button>
                <el-button :disabled="loading" size="mini" type="danger" @click="deleteSaleOrder(info.entryid,info.materialID,scope.row.billID)">删除</el-button>
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
              <span v-for="(info,index) in scope.row.info" v-if="scope.row.status !== '保存'">
                <el-button disabled size="mini" type="primary" @click="editSaleOrder(info.entryid,info.materialID,scope.row.billID)">修改数量</el-button>
                <el-button disabled size="mini" type="danger" @click="deleteSaleOrder(info.entryid,info.materialID,scope.row.billID)">删除</el-button>
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="saleIssueList" show-summary border :summary-method="getSaleIssueSummaries" size="mini" v-if="this.billType==='1'">
          <el-table-column label="付款" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="info" :disabled="loading" @click="toPay(scope.row.amount)">直接付款</el-button>
            </template>
          </el-table-column>
          <el-table-column label="单据编号" prop="billNumber" min-width="120px" align="center"></el-table-column>
          <el-table-column label="单据状态" prop="StatusToS" align="center"></el-table-column>
          <el-table-column label="商品名称" align="center">
            <template slot-scope="scope">
              <span class="spa" v-for="(info,index) in scope.row.info">
                {{info.materialName}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="规格" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.packSpec}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.baseQty}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="未提数量" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{'-'}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="金额（元）" prop="amount" align="center"></el-table-column>
          <el-table-column label="业务日期" prop="billDate" align="center"></el-table-column>
          <el-table-column label="备注" align="center" width="200px">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.description}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info" v-if="scope.row.status === '保存'">
                <el-button :disabled="loading" size="mini" type="primary" @click="editSaleOrder(info.entryid,info.materialID,scope.row.billID)">修改数量</el-button>
                <el-button :disabled="loading" size="mini" type="danger" @click="deleteSaleOrder(info.entryid,info.materialID,scope.row.billID)">删除</el-button>
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
              <span v-for="(info,index) in scope.row.info" v-if="scope.row.status !== '保存'">
                <el-button disabled size="mini" type="primary" @click="editSaleOrder(info.entryid,info.materialID,scope.row.billID)">修改数量</el-button>
                <el-button disabled size="mini" type="danger" @click="deleteSaleOrder(info.entryid,info.materialID,scope.row.billID)">删除</el-button>
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="salePlanList" show-summary border :summary-method="getSalePlanSummaries" size="mini" v-if="this.billType === '2'">
          <el-table-column label="付款" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="info" :disabled="loading" @click="toPay(scope.row.amount)">直接付款</el-button>
            </template>
          </el-table-column>
          <el-table-column label="单据编号" prop="billNumber" min-width="120px" align="center"></el-table-column>
          <el-table-column label="单据状态" prop="status" align="center"></el-table-column>
          <el-table-column label="商品名称" align="center">
            <template slot-scope="scope">
              <span class="spa" v-for="(info,index) in scope.row.info">
                {{info.materialName}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="规格" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.packSpec}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.qty}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="未提数量" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{'-'}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="金额（元）" prop="amount" align="center"></el-table-column>
          <el-table-column label="预测日期" prop="billDate" align="center"></el-table-column>
          <el-table-column label="备注" align="center" width="200px">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info">
                {{info.description}}
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px" align="center">
            <template slot-scope="scope">
              <span v-for="(info,index) in scope.row.info" v-if="scope.row.status === '保存'">
                <el-button :disabled="loading" size="mini" type="primary" @click="editSaleOrder(info.entryid,info.materialID,scope.row.billID)">修改数量</el-button>
                <el-button :disabled="loading" size="mini" type="danger" @click="deleteSaleOrder(info.entryid,info.materialID,scope.row.billID)">删除</el-button>
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
              <span v-for="(info,index) in scope.row.info" v-if="scope.row.status !== '保存'">
                <el-button disabled size="mini" type="primary" @click="editSaleOrder(info.entryid,info.materialID,scope.row.billID)">修改数量</el-button>
                <el-button disabled size="mini" type="danger" @click="deleteSaleOrder(info.entryid,info.materialID,scope.row.billID)">删除</el-button>
                <el-divider class="col" v-if="scope.row.info[index+1]!=null"></el-divider>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-main>
  </el-container>
</template>

<script>
import {queryBySale} from "../../../api/system/org-storage";
import {deleteSaleOrder, editSaleOrder, querySaleIssueBill, querySaleOrderFromEAS} from "../../../api/system/order";
import {queryCustomerListById} from "../../../api/system/person";
import {queryCenterSettle, queryCustomerLinkmanById, queryPersonListById} from "../../../api/system/customer";

export default {
  name: "index",
  data() {
    return {
      currentUser:'',
      saleOrgName:'',
      billType:'0',
      billStatus:'0',
      storageOrgInfo:'',
      storageOrgDef:{
        id:'',
        name:'',
        orgCompany:{
          name:''
        }
      },//默认库存组织
      customerName:'',
      beginDate:this.getDay(-6),
      endDate:this.getDay(0),
      saleOrderList:[],
      saleIssueList:[],
      salePlanList:[],
      customerInfo:[],
      customerList:[],
      customerOption:[],
      sumQty:0,
      sumUnQty:0,
      sumAmount:0,
      selectedCustomer:'',
      // selectedStorage:'',
      stoDef:'',
      loading:false,
      showClose:false
    }
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取当前销售组织ID
    this.saleOrgId = sessionStorage.getItem("saleOrgId")
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")

    this.queryUserInfo()
    this.queryOrgBySaleOrg()
  },
  methods: {
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    getSaleOrderSummaries() {
      const sums = [];
      sums[0] = '合计';
      sums[5] = this.sumQty;
      sums[6] = this.sumUnQty;
      sums[7] = this.sumAmount;
      return sums;
    },
    getSaleIssueSummaries() {
      const sums = [];
      sums[0] = '合计';
      sums[5] = this.sumIssueQty;
      sums[6] = '-';
      sums[7] = this.sumIssueAmount;
      return sums;
    },
    getSalePlanSummaries() {
      const sums = [];
      sums[0] = '合计';
      sums[5] = this.sumPlanQty;
      sums[6] = '-';
      sums[7] = '-';
      return sums;
    },
    queryUserInfo(){
      //获取原始销售组织列表
      this.queryOrgBySaleOrg2()
      if(this.currentUser.userType === 1){
        this.personInfo = this.currentUser.person
        this.queryCustomer()
      }else if(this.currentUser.userType === 2){
        this.customerInfo = this.currentUser.customer
        this.selectedCustomer = this.customerInfo.id
        this.queryPersonListById(this.customerInfo.number)
        this.queryCustomerLinkmanById(this.customerInfo.id)
      }
    },
    queryCenterSettle(){
      if(this.currentUser.userType === 2){
        this.selectedCustomer = this.currentUser.customer.id
      }
      if(this.selectedCustomer === ''){
        return
      }
      let param = {}
      param.saleOrgId = this.saleOrgId
      param.customerId = this.selectedCustomer
      queryCenterSettle(param).then(res => {
        //有客户与发货组织对应关系
        if(res.code === 200 && res.data !== null){
          //判断为业务员登录
          // if(this.currentUser.userType === 1){
          //不存在集中结算
          if(res.data.centreSettle === '0'){
            for(let i = 0; i < this.storageOrgInfo.length; i++){
              //设置为提货的库存组织和财务组织
              if(this.storageOrgInfo[i].id === res.data.storageOrgId && this.storageOrgInfo[i].orgCompany.id === res.data.storageOrgId) {
                this.storageOrgDef = this.storageOrgInfo[i]
                this.stoDef = i
                break;
              }
            }
            //插入一条，设置为默认的财务组织
          }else{
            let currentStorageOrg = this.storageOrgInfoTemp[0];
            currentStorageOrg.id = res.data.storageOrgId
            currentStorageOrg.name = res.data.storageOrgName
            //设置为默认的财务组织
            currentStorageOrg.orgCompany.id = this.storageOrgDefBak.orgCompany.id
            currentStorageOrg.orgCompany.name = this.storageOrgDefBak.orgCompany.name
            for(let i = 0; i < this.storageOrgInfo.length; i++){
              //设置为提货的库存组织和财务组织
              if(this.storageOrgInfo[i].id === res.data.storageOrgId && this.storageOrgInfo[i].orgCompany.id === currentStorageOrg.orgCompany.id) {
                this.storageOrgDef = this.storageOrgInfo[i]
                this.stoDef = i
                break;
              }
            }
            //判断组织列表里是否包含集中结算组织
            if(!this.storageOrgInfo.includes(currentStorageOrg)){
              this.storageOrgInfo.unshift(currentStorageOrg);
            }
          }
        }
      }).catch({

      })
    },
    // queryCenterSettle(){
    //   if(this.selectedCustomer === ''){
    //     return
    //   }
    //   let param = {}
    //   param.saleOrgId = this.saleOrgId
    //   param.customerId = this.selectedCustomer
    //   queryCenterSettle(param).then(res => {
    //     if(res.code === 200 && res.data !== null){
    //       if(this.currentUser.userType === 1){
    //         this.selectedStorage = res.data.storageOrgId
    //         this.storageOrgDef.id = res.data.storageOrgId
    //         this.storageOrgDef.name = res.data.storageOrgName
    //         for(let i = 0; i < this.storageOrgInfoTemp.length; i++){
    //           if(this.storageOrgInfo.length === this.storageOrgInfoTemp.length){
    //             this.storageOrgInfo.push(this.storageOrgInfoTemp[i])
    //           }
    //         }
    //       }else if(this.currentUser.userType === 2){
    //         this.selectedStorage = res.data.storageOrgId
    //         this.storageOrgDef.name = res.data.storageOrgName
    //
    //         //设置非集中结算的默认财务组织
    //         if(res.data.centreSettle === '0'){
    //           this.storageOrgDef.orgCompany.id = res.data.storageOrgId;
    //           this.storageOrgDef.orgCompany.name = res.data.storageOrgName;
    //         }
    //       }
    //     }else{
    //       if(this.currentUser.userType === 1) {
    //         this.queryOrgBySaleOrg()
    //       }
    //     }
    //   }).catch({
    //
    //   })
    // },
    queryOrgBySaleOrg2(){
      let param = {}
      param.id = this.saleOrgId
      queryBySale(param).then(res => {
        if (res.code === 200) {
          this.storageOrgInfoTemp = res.data
        }
      });
    },
    queryOrgBySaleOrg(){
      let param = {}
      param.id = this.saleOrgId
      queryBySale(param).then(res => {
        if(res.code === 200){
          // console.log(res.data)
          this.storageOrgInfo = res.data
          for(let i = 0; i < this.storageOrgInfo.length; i++){
            if(this.storageOrgInfo[i].isDefault === 1){
              this.storageOrgDef = this.storageOrgInfo[i]
              this.storageOrgDefBak = this.storageOrgInfo[i]
              this.stoDef = i
              break;
            }
          }
          // this.selectedStorage = this.storageOrgDef.id
          // console.log(this.storageOrgDef)
          if(this.currentUser.userType === 2){
            this.queryCenterSettle();
          }

        }else{
          this.$modal.msgError("获取您的组织信息失败，请联系营业室进行维护");
        }
      });
    },
    queryCustomer(){
      let param = {};
      let saleOrgList = [{id:this.saleOrgId}]
      param.number = this.personInfo.number
      param.orgSaleList = saleOrgList
      // console.log(param)
      queryCustomerListById(param).then(res => {
        if(res.code === 200){
          this.customerList = res.data
          this.customerOption = res.data
        }else{
          this.$modal.msgError("获取您的组织信息失败，请联系营业室进行维护");
        }
      });
    },

    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        this.showClose = false
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    cancelReadOnly(onOff) {
      if (onOff) { // 打开下拉框 显示可清空按钮
        this.showClose = true
      }
      this.$nextTick(() => {
        if (!onOff) {
          const {select} = this.$refs;
          const input = select.$el.querySelector('.el-input__inner');
          input.removeAttribute('readonly');
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    //下拉框开启搜索功能
    dataFilter(val) {
      this.value = val;
      if (val) { //val存在
        this.customerOption = this.customerList.filter((item) => {
          if (!!~item.name.indexOf(val) || !!~item.name.toUpperCase().indexOf(val.toUpperCase())) {
            return true
          }
        })
      } else { //val为空时，还原数组
        this.customerOption = this.customerList;
      }
    },

    queryBill(){
      if(this.billType === '0'){
        this.querySaleOrder()
      }else if(this.billType === '1'){
        this.querySaleIssueBill()
      }else if(this.billType === '2'){
        this.querySalePlan()
      }
    },
    querySaleOrder(){
      let param = {}
      param.bgDate = this.beginDate
      param.edDate = this.endDate
      param.companyId = this.saleOrgId
      // param.storageId = this.selectedStorage
      param.storageId = this.storageOrgInfo[this.stoDef].id
      param.billStatus = this.billStatus
      if(this.currentUser.userType === 1){
        param.customerID = this.selectedCustomer
      }else if (this.currentUser.userType === 2){
        param.customerID = this.customerInfo.id
      }
      if(param.customerID === ""){
        this.$modal.msg("请先选择客户");
        return
      }
      if(param.bgDate === null){
        this.$modal.msg("请选择开始日期");
        return
      }
      if(param.edDate === null){
        this.$modal.msg("请选择结束日期");
        return
      }
      this.loading = true
      // console.log(param)
      querySaleOrderFromEAS(param).then(res => {
        if(res.code === 200){
          if(res.data === null){
            this.$modal.msg("没有匹配数据");
            this.saleOrderList = []
            this.loading = false
            return
          }
          // console.log(res.data)
          this.saleOrderList = res.data.result
          for(let i = 0; i < this.saleOrderList.length; i++){
            for(let j = 0; j < this.saleOrderList[i].info.length; j++){
              this.saleOrderList[i].info[j].description = this.saleOrderList[i].description
            }
          }
          this.sumQty = res.data.allQty
          this.sumUnQty = res.data.allAssociateQty
          this.sumAmount = res.data.allAmount
          this.loading = false
        }else{
          this.loading = false
        }
      }).catch(()=>{
        this.loading = false
      });
    },
    querySaleIssueBill(){
      let param = {}
      // console.log(this.beginDate)
      // console.log(this.endDate)
      param.bgDate = this.beginDate
      param.edDate = this.endDate
      // param.companyId = this.selectedStorage
      param.companyId = this.storageOrgInfo[this.stoDef].id
      param.billStatus = this.billStatus
      if(this.currentUser.userType === 1){
        param.personID = this.personInfo.id
      }
      if(this.currentUser.userType === 1){
        param.customerID = this.selectedCustomer
      }else if (this.currentUser.userType === 2){
        param.customerID = this.customerInfo.id
      }
      if(param.customerID === ""){
        this.$modal.msg("请先选择客户");
        return
      }
      if(param.bgDate === null){
        this.$modal.msg("请选择开始日期");
        return
      }
      if(param.edDate === null){
        this.$modal.msg("请选择结束日期");
        return
      }
      this.loading = true
      // console.log(param)
      querySaleIssueBill(param).then(res => {
        if(res.code === 200){
          if(res.data === null){
            this.$modal.msg("没有匹配数据");
            this.saleIssueList = []
            this.loading = false
            return
          }
          // console.log(res.data)
          this.saleIssueList = res.data.result
          this.sumIssueQty = res.data.allQty
          this.sumIssueAmount = res.data.allAmount
          this.loading = false
        }else{
          this.loading = false
        }
      }).catch(()=>{
        this.loading = false
      });
    },
    querySalePlan(){
      let param = {}
      param.bgDate = this.beginDate
      param.edDate = this.endDate
      param.companyID = this.saleOrgId
      // param.storageId = this.selectedStorage
      param.storageId = this.storageOrgInfo[this.stoDef].id
      param.isPlan = '1'
      if(this.currentUser.userType === 1){
        param.salePersonID = this.personInfo.id
      }
      if(param.bgDate === null){
        this.$modal.msg("请选择开始日期");
        return
      }
      if(param.edDate === null){
        this.$modal.msg("请选择结束日期");
        return
      }
      this.loading = true
      // console.log(param)
      querySaleOrderFromEAS(param).then(res => {
        if(res.code === 200){
          if(res.data === null){
            this.$modal.msg("没有匹配数据");
            this.salePlanList = []
            this.loading = false
            return
          }
          // console.log(res.data)
          this.salePlanList = res.data.result
          for(let i = 0; i < this.salePlanList.length; i++){
            for(let j = 0; j < this.salePlanList[i].info.length; j++){
              this.salePlanList[i].info[j].description = this.salePlanList[i].description
            }
          }
          this.sumPlanQty = res.data.allQty
          //this.sumUnQty = res.data.allAssociateQty
          //this.sumPlanAmount = res.data.allAmount
          this.loading = false
        }else{
          this.loading = false
        }
      }).catch(()=>{
        this.loading = false
      });
    },
    editSaleOrder(entryId,materialId,billId){
      if(this.billType === '1'){
        return
      }
      this.$prompt('请输入修改后的数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[1-9]\d*\.?\d*/,
        inputErrorMessage: '数量格式不正确'
      }).then(({ value }) => {
        let param = {}
        param.billEntryID = entryId
        param.billID = billId
        param.materialId = materialId
        param.qty = value
        param.editWay = 'assist'
        // param.editWay = 'DUN'
        // console.log(param)
        this.loading = true
        editSaleOrder(param).then(res => {
          // console.log(res)
          if(res.code === 200){
            this.$modal.msgSuccess("商品数量修改成功！");
            this.querySaleOrder()
          }else{
            this.$modal.msgError("数量修改失败，请重试");
          }
        }).catch(()=>{
          this.loading = false
        });
      }).catch(() => {
        this.$modal.msg("已取消修改");
        this.loading = false
      })
    },
    queryPersonListById(val){
      let param = {}
      param.customerNumber = val
      param.orgSaleId = this.saleOrgId
      let paramList = []
      paramList.push(param)
      queryPersonListById(param).then(res => {
        if(res.code === 200){
          this.personInfo = res.data
        }else{
          this.$modal.msgError("获取您的业务员信息失败，请重试");
        }
      });
    },
    queryCustomerLinkmanById(val){
      let param = {}
      param.id = val
      param.orgSaleId = this.saleOrgId
      queryCustomerLinkmanById(param).then(res => {
        if(res.code === 200){
          this.linkManInfo = res.data
        }else{
          this.$modal.msgError("获取您的订货公司信息失败，请重试");
        }
      });
    },
    deleteSaleOrder(entryId,materialId,billId){
      this.$confirm("确定要删除此商品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = {}
        param.billEntryID = entryId
        param.billID = billId
        param.materialId = materialId
        // console.log(param)
        this.loading = true
        deleteSaleOrder(param).then(res => {
          if(res.code === 200){
            this.$modal.msgSuccess("订单删除成功！");
            this.querySaleOrder()
          }else{
            this.$modal.msgError("订单删除失败，请重试");
          }
        }).catch(()=>{
          this.loading = false
        });
      }).catch(() => {
        this.$modal.msg("已取消删除");
        this.loading = false
      });
    },
    getDay(day) {
      //Date()返回当日的日期和时间。
      let days = new Date();
      //getTime()返回 1970 年 1 月 1 日至今的毫秒数。
      let getTimes = days.getTime() + 1000 * 60 * 60 * 24 * day;
      //setTime()以毫秒设置 Date 对象。
      days.setTime(getTimes);
      let year = days.getFullYear();
      let month = days.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let today = days.getDate();
      if (today < 10) {
        today = "0" + today;
      }
      return year + "-" + month + "-" + today;
    },
    toPay(val){
      if(val <= 0){
        this.$message.warning('付款金额错误，请重试')
        return
      }
      this.$router.push({ path: "/finance/pay",query:{amount:val,selectedCustomer:this.selectedCustomer}});
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 90vh;
    margin-top: -10px;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .con{
    margin-top: 10px;
    border: 1px solid rgb(196, 196, 196);
  }
  .list{
    margin-top: 30px;
    border: 1px solid rgb(196, 196, 196);
  }
  .but1{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .icon_product{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
  }
  .submit{
    text-align: center;
  }
  /*.but{*/
  /*  width: 200px;*/
  /*  font-size: 14px;*/
  /*  color: white;*/
  /*  border: none;*/
  /*  background: linear-gradient(180.00deg, rgba(239,50,68,1) 0%,rgba(246,88,104,1) 100%);*/
  /*}*/
  .but{
    width: 160px;
    font-size: 16px;
    color: white;
    border: none;
    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1.00) 0%,rgba(253,131,145,1.00) 100%);
    border-radius: 20px;
  }
  .sum{
    font-weight: bold;
  }
  .sp3{
    color: rgb(240, 57, 74);;
  }
  .div_top{
    margin: 12px 0;
  }
  .col{
    margin: 6px -10px;
    width: 200%;
    background-color:#EBEEF5;
  }
  ::v-deep .el-table .cell{
    line-height: 30px;
  }
  .spa{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
  }
</style>
